// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3-_IH","title":"ClientCherryInfo_title__11T2A","itemText":"ClientCherryInfo_itemText__JzQNE"};